export default "__VITE_ASSET__vu6QlrIl__"